import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import Home from "@/pages/Home";
import Biography from "@/pages/Biography";
import Expertise from "@/pages/Expertise";
import Media from "@/pages/Media";
import MediaItem from "@/pages/MediaItem";
import Speaking from "@/pages/Speaking";
import ThoughtLeadership from "@/pages/ThoughtLeadership";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function Shell({ children }) {
  return (
    <div className="App">
      <Header />
      <main data-testid="main-content">{children}</main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            fontFamily: "'Manrope', sans-serif",
            border: "1px solid #0A1128",
            borderRadius: 0,
            background: "#0A1128",
            color: "#FDFDFD",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell>
        <Routes>
          <Route path="/" element={<Navigate to="/leadership" replace />} />
          <Route path="/leadership" element={<Home />} />
          <Route path="/leadership/biography" element={<Biography />} />
          <Route path="/leadership/expertise" element={<Expertise />} />
          <Route path="/leadership/media" element={<Media />} />
          <Route path="/leadership/media/:slug" element={<MediaItem />} />
          <Route path="/leadership/speaking" element={<Speaking />} />
          <Route path="/leadership/thought-leadership" element={<ThoughtLeadership />} />
          <Route path="/leadership/thought-leadership/:slug" element={<Article />} />
          <Route path="/leadership/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Shell>
    </BrowserRouter>
  );
}
